import { __decorate, __extends } from "tslib";
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { list as extraList } from '../../api/extras';
import { list as hygieneList } from '../../api/hygienes';
import { list as productList } from '../../api/products';
import { list as notificationList } from '../../api/push';
import { sendPush } from '../../api/push';
import { Button } from '../../components/Button';
import { Dropdown } from '../../components/Dropdown';
import { PushItem } from '../../components/PushItem';
import { SpinnerBlock } from '../../components/Spinner';
import { customConfirm } from '../../utils/utils';
import S from './pushNotifications.styl';
export var DeeplinkType;
(function (DeeplinkType) {
    DeeplinkType["home"] = "home";
    DeeplinkType["models"] = "models";
    DeeplinkType["products"] = "products";
    DeeplinkType["extra"] = "extra";
    DeeplinkType["hygiene"] = "hygiene";
})(DeeplinkType || (DeeplinkType = {}));
var PushNotificationsView = /** @class */ (function (_super) {
    __extends(PushNotificationsView, _super);
    function PushNotificationsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            contentInputError: false,
        };
        _this.deeplinks = [DeeplinkType.home, DeeplinkType.hygiene, DeeplinkType.models, DeeplinkType.products, DeeplinkType.extra];
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
            if (name === 'content') {
                _this.setState({ contentInputError: false });
            }
        };
        _this.onDeeplinkChange = function (deeplink) {
            _this.setState({
                selectedDeeplink: deeplink,
                selectedProduct: undefined,
                selectedHygiene: undefined,
                selectedExtra: undefined,
            });
        };
        _this.onProductSelected = function (product) {
            _this.setState({
                selectedProduct: product,
            });
        };
        _this.onHygieneSelected = function (hygiene) {
            _this.setState({
                selectedHygiene: hygiene,
            });
        };
        _this.onExtraSelected = function (extra) {
            _this.setState({
                selectedExtra: extra,
            });
        };
        _this.onUpdate = function () {
            _this.fetchNotifications();
        };
        return _this;
    }
    PushNotificationsView.prototype.componentDidMount = function () {
        var _this = this;
        productList().then(function (products) {
            _this.setState({
                products: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        hygieneList().then(function (hygienes) {
            _this.setState({
                hygienes: (hygienes === null || hygienes === void 0 ? void 0 : hygienes.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        extraList().then(function (products) {
            _this.setState({
                extras: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        this.fetchNotifications();
    };
    PushNotificationsView.prototype.fetchNotifications = function () {
        var _this = this;
        notificationList().then(function (notifications) {
            _this.setState({
                notifications: (notifications === null || notifications === void 0 ? void 0 : notifications.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    PushNotificationsView.prototype.onSubmit = function (event) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var i18n = this.props.store.i18n;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        var content = elements.content.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        if (content.length === 0) {
            this.setState({ contentInputError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var contentId;
        if ((_a = this.state.selectedProduct) === null || _a === void 0 ? void 0 : _a.id) {
            contentId = (_b = this.state.selectedProduct) === null || _b === void 0 ? void 0 : _b.id;
        }
        else if ((_c = this.state.selectedHygiene) === null || _c === void 0 ? void 0 : _c.id) {
            contentId = (_d = this.state.selectedHygiene) === null || _d === void 0 ? void 0 : _d.id;
        }
        else if ((_e = this.state.selectedExtra) === null || _e === void 0 ? void 0 : _e.id) {
            contentId = (_f = this.state.selectedExtra) === null || _f === void 0 ? void 0 : _f.id;
        }
        var request = {
            title: title,
            content: content,
            deeplink: this.state.selectedDeeplink,
            contentId: contentId,
        };
        customConfirm(i18n.pushNotificationsConfirm, this.props.store, function (success) {
            if (success) {
                _this.setState({ loading: true });
                sendPush(request).then(function () {
                    _this.setState({
                        loading: false,
                        selectedDeeplink: undefined,
                        selectedProduct: undefined,
                        selectedHygiene: undefined,
                        selectedExtra: undefined,
                    });
                    elements.title.value = '';
                    elements.content.value = '';
                    _this.fetchNotifications();
                }).catch(function (error) {
                    _this.setState({ loading: false });
                    alert(error);
                });
            }
        });
    };
    PushNotificationsView.prototype.getDeeplinkText = function (deeplink) {
        var i18n = this.props.store.i18n;
        if (deeplink === DeeplinkType.home) {
            return i18n.sideBarHome;
        }
        else if (deeplink === DeeplinkType.products) {
            return i18n.productsTitle;
        }
        else if (deeplink === DeeplinkType.extra) {
            return i18n.sideBarExtras;
        }
        else if (deeplink === DeeplinkType.hygiene) {
            return i18n.sideBarHygienes;
        }
        else {
            return i18n.modelsTitle;
        }
    };
    PushNotificationsView.prototype.isProductDeeplink = function () {
        return this.state.selectedDeeplink === DeeplinkType.products;
    };
    PushNotificationsView.prototype.isExtraDeeplink = function () {
        return this.state.selectedDeeplink === DeeplinkType.extra;
    };
    PushNotificationsView.prototype.isHygieneDeeplink = function () {
        return this.state.selectedDeeplink === DeeplinkType.hygiene;
    };
    PushNotificationsView.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this, props = _d.props, state = _d.state;
        var _e = this.state, loading = _e.loading, notifications = _e.notifications;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.pushNotificationsView },
            React.createElement("h1", { className: S.pushNotificationsTitle }, i18n.pushNotificationsTitle),
            React.createElement("hr", { className: S.pushNotificationsSeparator }),
            React.createElement("div", { className: S.pushNotificationsMainBox },
                React.createElement("p", { className: S.pushHeaderText }, i18n.pushNotificationsSendTitle),
                React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("div", { className: S.addInputWrapper },
                            React.createElement("label", { className: S.addInputTitle }, i18n.pushNotificationsFormTitle),
                            React.createElement("input", { className: S.addInput + " textInput", name: "title", onInput: this.onChangeAction, placeholder: i18n.pushNotificationsFormTitle })),
                        React.createElement("p", { className: "inputError " + S.addInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("div", { className: S.addTextareaWrapper },
                            React.createElement("label", { className: S.addInputTitle }, i18n.pushNotificationsFormContent),
                            React.createElement("textarea", { className: S.addInput + " textInput", name: "content", onInput: this.onChangeAction, placeholder: i18n.pushNotificationsFormContent })),
                        React.createElement("p", { className: "inputError " + S.addInputError + " " + (this.state.contentInputError ? 'inputErrorActive' : '') }, i18n.validationContentError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputDeeplink),
                        React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + (state.selectedDeeplink ? this.getDeeplinkText(state.selectedDeeplink) : i18n.inputChoose) },
                            React.createElement(Dropdown.List, null,
                                React.createElement(Dropdown.Item, { key: -1, data: "product", autoClose: true, onClick: function (_) { return _this.onDeeplinkChange(); } }, i18n.inputChoose),
                                this.deeplinks.map(function (deeplink, index) { return (React.createElement(Dropdown.Item, { key: index, data: "deeplinkItem", autoClose: true, onClick: function (_) { return _this.onDeeplinkChange(deeplink); } }, _this.getDeeplinkText(deeplink))); }))),
                        this.isProductDeeplink() &&
                            React.createElement(React.Fragment, null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.productsTitle),
                                React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: this.state.selectedProduct ? (this.state.selectedProduct.title + ' ' + ("(ID: " + this.state.selectedProduct.id + ")")) : "" + i18n.inputChoose },
                                    React.createElement(Dropdown.List, null,
                                        React.createElement(Dropdown.Item, { key: -1, data: "product", autoClose: true, onClick: function (_) { return _this.onProductSelected(); } }, i18n.inputChoose), (_a = this.state.products) === null || _a === void 0 ? void 0 :
                                        _a.map(function (product, index) { return (React.createElement(Dropdown.Item, { key: index, data: "product", autoClose: true, onClick: function (_) { return _this.onProductSelected(product); } }, product === null || product === void 0 ? void 0 :
                                            product.title,
                                            " (ID: ", product === null || product === void 0 ? void 0 :
                                            product.id,
                                            ")")); })))),
                        this.isHygieneDeeplink() &&
                            React.createElement(React.Fragment, null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.sideBarHygienes),
                                React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: this.state.selectedHygiene ? (this.state.selectedHygiene.title + ' ' + ("(ID: " + this.state.selectedHygiene.id + ")")) : "" + i18n.inputChoose },
                                    React.createElement(Dropdown.List, null,
                                        React.createElement(Dropdown.Item, { key: -1, data: "product", autoClose: true, onClick: function (_) { return _this.onHygieneSelected(); } }, i18n.inputChoose), (_b = this.state.hygienes) === null || _b === void 0 ? void 0 :
                                        _b.map(function (hygiene, index) { return (React.createElement(Dropdown.Item, { key: index, data: "product", autoClose: true, onClick: function (_) { return _this.onHygieneSelected(hygiene); } }, hygiene === null || hygiene === void 0 ? void 0 :
                                            hygiene.title,
                                            " (ID: ", hygiene === null || hygiene === void 0 ? void 0 :
                                            hygiene.id,
                                            ")")); })))),
                        this.isExtraDeeplink() &&
                            React.createElement(React.Fragment, null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.sideBarExtras),
                                React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: this.state.selectedExtra ? (this.state.selectedExtra.title + ' ' + ("(ID: " + this.state.selectedExtra.id + ")")) : "" + i18n.inputChoose },
                                    React.createElement(Dropdown.List, null,
                                        React.createElement(Dropdown.Item, { key: -1, data: "extra", autoClose: true, onClick: function (_) { return _this.onExtraSelected(); } }, i18n.inputChoose), (_c = this.state.extras) === null || _c === void 0 ? void 0 :
                                        _c.map(function (extra, index) { return (React.createElement(Dropdown.Item, { key: index, data: "extra", autoClose: true, onClick: function (_) { return _this.onExtraSelected(extra); } }, extra === null || extra === void 0 ? void 0 :
                                            extra.title,
                                            " (ID: ", extra === null || extra === void 0 ? void 0 :
                                            extra.id,
                                            ")")); }))))),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.pushModalButton, type: "submit", spinner: loading }, i18n.actionSend))),
            React.createElement("hr", { className: S.pushNotificationsSeparator }),
            React.createElement("p", { className: S.pushHeaderText }, i18n.pushNotificationsTitle),
            React.createElement("div", { className: S.pushNotificationsMainBoxList }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.pushNotificationsHeader },
                            React.createElement("div", { className: S.tableCell + " titleCell" }, i18n.modelsItemTitle),
                            React.createElement("div", { className: S.action }, i18n.productsAction)),
                        React.createElement("div", { className: S.list }, notifications === null || notifications === void 0 ? void 0 : notifications.map(function (notification, i) { return (React.createElement(PushItem, { key: i, notification: notification, isUpdated: _this.onUpdate })); })))),
            React.createElement("br", null),
            React.createElement("br", null)));
    };
    __decorate([
        action.bound
    ], PushNotificationsView.prototype, "onSubmit", null);
    PushNotificationsView = __decorate([
        inject('store'),
        observer
    ], PushNotificationsView);
    return PushNotificationsView;
}(React.Component));
export { PushNotificationsView };
